
import {VideotronPhone} from './app/VideotronPhone.js'
window.VideotronPhone = VideotronPhone;
